import $ from 'jquery';
import pluralize from 'pluralize';
import EventBus from '../../common/EventBus';

const SELECTORS = {
  indicator: '.js-basket-no-of-items',
  itemCountText: 'span',
};

const ATTRIBUTES = {
  numberOfItems: 'data-number-of-items',
  itemSingularName: 'item-singular-name',
};

export default class BasketIndicator {
  constructor() {
    this.indicator = $(SELECTORS.indicator);
    this._subscribeToEvents();
  }

  _subscribeToEvents() {
    EventBus.on('jobs:added', (data) => this.update(data.jobs.length));
    EventBus.on('jobs:removed', (data) => this.update(data.jobs.length));
    EventBus.on('jobs:cleared', (data) => this.update(data.jobs.length));
  }

  update(jobsCount) {
    this.indicator.attr(ATTRIBUTES.numberOfItems, jobsCount.toString()).each(function () {
      const $this = $(this);
      const singularName = $this.data(ATTRIBUTES.itemSingularName);

      const text = singularName ? pluralize(singularName, jobsCount, true) : jobsCount.toString();
      $this.children(SELECTORS.itemCountText).text(text);
    });
  }
}
